import { createFileRoute } from "@tanstack/react-router";
import { ClientsStatsScreen } from "../components/clients/ClientsStatsScreen";

export const Route = createFileRoute("/_auth/clients/stats")({
  staticData: {
    titleKey: "clients.stats.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 3,
  },
  component: ClientsStatsScreen,
});
